










import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppAddCustomer extends Vue {
  getRouteAddCustomer() {
    return this.$router.push("/customers/customer/add-customer");
  }
}
